<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    modelValue?: string;
    placeholder?: string;
    minHeight?: string;
    rows?: number;
  }>(),
  {
    modelValue: "",
    placeholder: "",
    minHeight: "100px",
    rows: 4,
  },
);

const emit = defineEmits<{ "update:modelValue": [value: string] }>();
const value = computed({
  get: () => props.modelValue,
  set: (nextValue: string) => emit("update:modelValue", nextValue),
});
</script>

<template>
  <textarea
    v-model="value"
    class="v-textarea"
    :placeholder="placeholder"
    :rows="rows"
    :style="{ minHeight }"
  />
</template>

<style scoped>
.v-textarea {
  box-sizing: border-box;
  display: block;
  width: 100%;
  margin: 8px 0;
  padding: 10px;
  resize: vertical;
  border: 1px solid #cecece;
  border-radius: 4px;
  outline: none;
  background: #fff;
  color: #303030;
  font-family: var(--font-sans);
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-normal);
}
.v-textarea::placeholder {
  color: #838383;
  opacity: 1;
}
.v-textarea:focus-visible {
  border-color: #3377ff;
  box-shadow: 0 0 0 2px rgb(51 119 255 / 18%);
}
.v-textarea:disabled {
  cursor: not-allowed;
  background: #f5f5f5;
  color: #8a8a8a;
}
</style>
